var _rect, _rect2, _rect3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerformanceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 26.2,
    rx: 5.5,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 26.2,
    rx: 5.5,
    stroke: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2317_6344",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 4,
    width: 20,
    height: 20
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 4,
    width: 19.1062,
    height: 19.1062,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2317_6344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3995 20.718L17.6578 16.9764C17.1138 17.401 16.5135 17.7327 15.8567 17.9715C15.1999 18.2103 14.5 18.3298 13.757 18.3298C12.5629 18.3298 11.4848 18.0379 10.5229 17.4541C9.56092 16.8703 8.80132 16.1007 8.24405 15.1454H10.1945C10.6456 15.6363 11.173 16.0244 11.7767 16.3097C12.3804 16.5949 13.0405 16.7376 13.757 16.7376C15.0838 16.7376 16.2116 16.2732 17.1404 15.3444C18.0692 14.4156 18.5335 13.2878 18.5335 11.961C18.5335 10.6342 18.0692 9.5064 17.1404 8.57763C16.2116 7.64886 15.0838 7.18447 13.757 7.18447C12.5098 7.18447 11.4317 7.60573 10.5229 8.44826C9.61399 9.29079 9.10649 10.329 9.00034 11.563H7.40816C7.5143 9.87791 8.1744 8.46153 9.38844 7.31383C10.6025 6.16613 12.0587 5.59229 13.757 5.59229C15.5349 5.59229 17.0409 6.20926 18.2748 7.4432C19.5088 8.67714 20.1257 10.1831 20.1257 11.961C20.1257 12.704 20.0063 13.4039 19.7675 14.0607C19.5287 14.7175 19.1969 15.3179 18.7724 15.8619L22.514 19.6035L21.3995 20.718ZM12.9012 15.1454L11.6473 11.0057L10.6124 13.9512H6.59216V12.7571H9.77653L11.0901 8.97568H12.2842L13.4983 13.0357L14.3541 10.3688H15.5482L16.7423 12.7571H17.3394V13.9512H16.0059L15.0705 12.0804L14.0754 15.1454H12.9012Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformanceIcon);
export default __webpack_public_path__ + "static/media/PerformanceIcon.4fbc6597b54031615cebd7f731de2d1e.svg";
export { ForwardRef as ReactComponent };